
import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    // Check if user has a stored preference
    if (typeof window !== 'undefined') {
      const storedTheme = localStorage.getItem('theme') as Theme | null;
      
      // Check if user prefers dark mode based on system preferences
      if (!storedTheme) {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        return prefersDark ? 'dark' : 'light';
      }
      
      return storedTheme || 'light';
    }
    
    return 'light'; // Default fallback
  });

  // Update the theme attribute on the html element whenever theme changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const root = window.document.documentElement;
      
      // Remove the old theme class
      root.classList.remove('light', 'dark');
      
      // Add the new theme class
      root.classList.add(theme);
      
      // Save the theme preference to localStorage
      localStorage.setItem('theme', theme);
      
      // Update the :root variables with JS
      document.documentElement.style.setProperty(
        '--quote-bubble-color', 
        theme === 'dark' ? '#2a2d36' : '#f3f4f6'
      );
    }
  }, [theme]);

  return { theme, setTheme };
}
